<template>
    <div class="container">
        <headerNavbar title="历史对比" />
        <van-notice-bar :scrollable="false" text="选择2份或以上报告进行对比" />
        <div v-if="reports && reports.length>0">
            <van-checkbox-group v-model="selectedReports">
                <van-cell-group>
                    <van-cell v-for="(rep, index) in reports" clickable :key="rep.tjbh"
                        :title="`${rep.name}   体检日期: ${rep.tjrq}`" @click="toggle(index)">
                        <template #right-icon>
                            <van-checkbox :name="rep.tjbh" ref="checkboxes" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </div>

        <div class="report-compare-wrapper">
            <van-button type="info" @click="startCompare()" size="large" :disabled="selectedReports.length<=1">开始对比
            </van-button>
        </div>
    </div>
</template>
<style lang="less" scoped>
    /deep/ .van-step--finish .van-step__circle {
        background-color: var(--color-main);
    }

    .container {
        min-height: 100vh;
    }

    .report-list-wrapper {
        margin-top: 20px;
    }

    .report-compare-wrapper {
        margin-top: 20px;
        padding: 16px;
    }
</style>

<script>
    import Vue from "vue";
    import {
        Step,
        Steps,
        Toast
    } from "vant";
    import headerNavbar from '../components/headerNavbar';
    Vue.use(Step);
    Vue.use(Steps);
    import * as api_user from "@/api/user";
    import * as auth from "@/libs/auth";
    import * as api_report from "@/api/report";
    export default {
        components: {
            headerNavbar
        },
        data() {
            return {
                userProfile: null,
                reports: null,
                selectedReports: [],
            };
        },
        async mounted() {
            let userInfo = api_user.getLoginedUser();
            let _this = this;
            if (userInfo) {
                api_user.getUserProfiles().then(
                    res => {
                        if (res.code == "200" && res.data) {
                            let profileId = _this.$route.query.profileId;
                            return api_report.getReports(profileId);
                        }
                    }
                ).then(
                    result => {
                        if (result && result.code == 200) {
                            // 20230829 国宾要求质控后的报告才能显示
                            if (result.data && result.data.length > 0) {
                                this.reports = result.data.filter(r => {
                                    return r.zjzt > 0 && r.qcResult != '0';
                                });
                            }
                        }
                    }
                ).catch(err => {
                    console.log(err);
                    this.$Toast("查询体检报告出错")
                });
            }
        },
        //
        methods: {
            toggle(index) {
                this.$refs.checkboxes[index].toggle();
            },
            startCompare() {
                let tjbh = this.selectedReports.join(',');
                console.log(tjbh);
                this.$router.push({
                    path: '/report/comparePage',
                    query: {
                        tjbh: tjbh
                    }
                })
            },
        },
    };
</script>